import { useEffect, useState } from "react";
import { SITE } from "../config/site";

const LINKS = [
  { label: "Services", href: "#services" },
  { label: "Why Us", href: "#why-us" },
  { label: "Areas", href: "#areas" },
  { label: "Scheduling", href: "#scheduling" },
  { label: "Pricing", href: "#pricing" },
  { label: "FAQ", href: "#faq" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed inset-x-0 top-0 z-50 transition-[background-color,box-shadow] duration-500 ${
        scrolled
          ? "bg-white/90 backdrop-blur-xl shadow-[0_1px_0_rgba(14,53,39,0.08)]"
          : "bg-white/70 backdrop-blur-md"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 lg:px-12">
        <a href="#top" data-testid="nav-logo" className="leading-none" aria-label={`${SITE.name} — home`}>
          <img
            src="/logo.png"
            alt={`${SITE.name} logo`}
            className="h-11 w-auto rounded-md"
          />
        </a>
        <nav className="hidden items-center gap-8 md:flex">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="text-sm font-medium text-ink/70 transition-colors duration-300 hover:text-seafoam"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <a
          href="#quote"
          data-testid="nav-quote-button"
          className="rounded-full bg-ocean px-5 py-2.5 text-sm font-semibold text-salt transition-[background-color,transform] duration-300 hover:bg-seafoam hover:scale-[1.03]"
        >
          Get a Free Quote
        </a>
      </div>
    </header>
  );
}
